var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 34,
    viewBox: "0 0 111 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 110,
    height: 34,
    rx: 3.90533,
    fill: "#090909"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_4972_524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2401 7.89707C13.007 8.12205 12.8691 8.4712 12.8691 8.92334V25.0777C12.8691 25.5306 13.007 25.879 13.2401 26.104L13.2994 26.1566L23.2265 17.1072V17.0005V16.8939L13.2994 7.84375L13.2401 7.89707Z",
    fill: "url(#paint0_linear_4972_524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5351 20.1224L23.2266 17.105V16.9984V16.8917L26.5359 13.875L26.6104 13.9137L30.531 15.9443C31.6504 16.5243 31.6504 17.4731 30.531 18.0538L26.6104 20.0845L26.5351 20.1224Z",
    fill: "url(#paint1_linear_4972_524)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_4972_524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6124 20.0854L23.2277 17L13.2422 26.1035C13.6108 26.4599 14.2206 26.5037 14.9072 26.1488L26.6124 20.0854Z",
    fill: "url(#paint2_linear_4972_524)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.6124 13.9136L14.9072 7.85095C14.2206 7.49523 13.6108 7.53978 13.2422 7.89624L23.2285 16.9997L26.6124 13.9136Z",
    fill: "url(#paint3_linear_4972_524)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.4789 17.9067C52.6989 17.9067 51.2482 19.1355 51.2482 20.8279C51.2482 22.5099 52.6989 23.749 54.4789 23.749C56.2596 23.749 57.7104 22.5099 57.7104 20.8279C57.7096 19.1355 56.2588 17.9067 54.4789 17.9067ZM54.4789 22.5992C53.5034 22.5992 52.6626 21.8691 52.6626 20.8285C52.6626 19.777 53.5042 19.0579 54.4789 19.0579C55.4544 19.0579 56.2952 19.777 56.2952 20.8285C56.2952 21.8684 55.4544 22.5992 54.4789 22.5992ZM47.4302 17.9067C45.6503 17.9067 44.1995 19.1355 44.1995 20.8279C44.1995 22.5099 45.6503 23.749 47.4302 23.749C49.2109 23.749 50.6617 22.5099 50.6617 20.8279C50.6617 19.1355 49.2109 17.9067 47.4302 17.9067ZM47.4302 22.5992C46.4547 22.5992 45.6139 21.8691 45.6139 20.8285C45.6139 19.777 46.4555 19.0579 47.4302 19.0579C48.4057 19.0579 49.2465 19.777 49.2465 20.8285C49.2473 21.8684 48.4057 22.5992 47.4302 22.5992ZM39.0466 18.8037V20.0428H42.3144C42.2167 20.7399 41.9609 21.2489 41.5704 21.6026C41.0952 22.034 40.3513 22.5099 39.0466 22.5099C37.035 22.5099 35.4624 21.038 35.4624 19.2124C35.4624 17.3868 37.035 15.9149 39.0466 15.9149C40.1318 15.9149 40.9242 16.3022 41.5091 16.8002L42.4725 15.9258C41.6552 15.2177 40.5707 14.6758 39.0466 14.6758C36.2911 14.6758 33.9746 16.7116 33.9746 19.2124C33.9746 21.7132 36.2911 23.749 39.0466 23.749C40.5336 23.749 41.656 23.306 42.5331 22.4763C43.4352 21.6576 43.7159 20.5064 43.7159 19.5771C43.7159 19.29 43.6917 19.0242 43.6425 18.803L39.0466 18.8037ZM73.3349 19.766C73.067 19.1135 72.2497 17.9067 70.5795 17.9067C68.9213 17.9067 67.5432 19.0908 67.5432 20.8279C67.5432 22.4653 68.9092 23.749 70.7376 23.749C72.2126 23.749 73.0662 22.9303 73.4204 22.4543L72.3231 21.7901C71.9576 22.2771 71.4573 22.5979 70.7376 22.5979C70.0187 22.5979 69.5063 22.2991 69.1771 21.7125L73.481 20.0971L73.3349 19.766ZM68.9456 20.7399C68.9092 19.6108 69.9089 19.0359 70.6286 19.0359C71.1894 19.0359 71.6647 19.2907 71.8236 19.6554L68.9456 20.7399ZM65.447 23.5725H66.8606V14.9862H65.447V23.5725ZM63.1297 18.5599H63.0812C62.7642 18.2165 62.1542 17.9067 61.3868 17.9067C59.7771 17.9067 58.3022 19.1904 58.3022 20.8395C58.3022 22.477 59.7771 23.7497 61.3868 23.7497C62.1549 23.7497 62.7642 23.4399 63.0812 23.0862H63.1297V23.5066C63.1297 24.6241 62.4713 25.2216 61.411 25.2216C60.5453 25.2216 60.0087 24.6577 59.7892 24.1817L58.558 24.6467C58.9114 25.4208 59.8498 26.3728 61.411 26.3728C63.0691 26.3728 64.4715 25.4874 64.4715 23.3294V18.0846H63.1304L63.1297 18.5599ZM61.5087 22.5992C60.5332 22.5992 59.7166 21.8574 59.7166 20.8395C59.7166 19.81 60.5332 19.0579 61.5087 19.0579C62.4713 19.0579 63.2273 19.81 63.2273 20.8395C63.2273 21.8574 62.4713 22.5992 61.5087 22.5992ZM79.9598 14.9862H76.5762V23.5725H77.9876V20.3196H79.959C81.5241 20.3196 83.0634 19.2914 83.0634 17.6533C83.0634 16.0151 81.5248 14.9862 79.9598 14.9862ZM79.9961 19.1245H77.9876V16.1813H79.9961C81.0518 16.1813 81.6512 16.9747 81.6512 17.6533C81.6512 18.3181 81.0518 19.1245 79.9961 19.1245ZM88.7233 17.8916C87.7009 17.8916 86.6422 18.3003 86.204 19.2062L87.4572 19.6808C87.7251 19.2062 88.2246 19.051 88.7475 19.051C89.4778 19.051 90.2202 19.4487 90.2324 20.1554V20.244C89.9766 20.1115 89.4287 19.913 88.7597 19.913C87.4088 19.913 86.033 20.5868 86.033 21.8458C86.033 22.9949 87.1409 23.7346 88.382 23.7346C89.331 23.7346 89.8547 23.3479 90.1832 22.8946H90.2316V23.5574H91.5953V20.2653C91.5961 18.7419 90.3413 17.8916 88.7233 17.8916ZM88.5523 22.5972C88.0907 22.5972 87.4451 22.387 87.4451 21.8677C87.4451 21.2049 88.2488 20.9508 88.9428 20.9508C89.5626 20.9508 89.8555 21.0724 90.2324 21.2379C90.1226 22.034 89.3681 22.5972 88.5523 22.5972ZM96.5613 18.0791L94.9426 21.8018H94.8941L93.2141 18.0791H91.6929L94.2123 23.282L92.7759 26.1763H94.2486L98.1317 18.0791H96.5613ZM83.8428 23.5725H85.2542V14.9862H83.8428V23.5725Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8697 9.90701C38.8697 10.4722 38.6822 10.922 38.3064 11.2578C37.88 11.6571 37.3235 11.8567 36.64 11.8567C35.9852 11.8567 35.4279 11.6544 34.9705 11.2497C34.5123 10.8444 34.2832 10.3427 34.2832 9.7438C34.2832 9.14426 34.5123 8.6425 34.9705 8.23786C35.4279 7.83254 35.9852 7.63022 36.64 7.63022C36.9651 7.63022 37.2759 7.68687 37.5708 7.7995C37.8664 7.9128 38.103 8.06319 38.28 8.25135L37.8815 8.60743C37.5813 8.28709 37.1677 8.12726 36.6392 8.12726C36.1614 8.12726 35.7485 8.27698 35.4 8.57641C35.0514 8.87584 34.8775 9.26497 34.8775 9.74313C34.8775 10.2213 35.0514 10.6104 35.4 10.9098C35.7485 11.2093 36.1614 11.359 36.6392 11.359C37.1458 11.359 37.5685 11.2086 37.9065 10.9071C38.1257 10.7109 38.2528 10.4378 38.2868 10.0877H36.6392V9.6015H38.8372C38.8599 9.70738 38.8697 9.80922 38.8697 9.90701Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3555 8.21699H40.2898V9.4997H42.1528V9.98595H40.2898V11.2687H42.3555V11.7664H39.7068V7.71996H42.3555V8.21699Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8135 11.7664H44.2305V8.21699H42.9633V7.71996H46.0807V8.21699H44.8135V11.7664Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3361 11.7664V7.71996H48.9191V11.7664H48.3361Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5043 11.7664H50.9214V8.21699H49.6542V7.71996H52.7716V8.21699H51.5043V11.7664Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6728 11.2437C58.2267 11.6524 57.6725 11.8567 57.0094 11.8567C56.3463 11.8567 55.792 11.6524 55.3467 11.2437C54.9006 10.835 54.6783 10.3346 54.6783 9.74316C54.6783 9.15171 54.9006 8.6513 55.3467 8.24261C55.792 7.83392 56.3463 7.62891 57.0094 7.62891C57.6687 7.62891 58.2222 7.8346 58.6698 8.24531C59.1174 8.65602 59.3412 9.15508 59.3412 9.74316C59.3412 10.3346 59.1182 10.835 58.6728 11.2437ZM55.7769 10.9045C56.1126 11.208 56.5232 11.359 57.0094 11.359C57.4956 11.359 57.9069 11.2073 58.2418 10.9045C58.5775 10.601 58.7462 10.2139 58.7462 9.74316C58.7462 9.27242 58.5775 8.88532 58.2418 8.58184C57.9069 8.27836 57.4956 8.12729 57.0094 8.12729C56.5232 8.12729 56.1126 8.27903 55.7769 8.58184C55.442 8.88532 55.2734 9.27242 55.2734 9.74316C55.2734 10.2139 55.442 10.601 55.7769 10.9045Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1593 11.7664V7.71996H60.8686L63.0734 10.8674H63.0983L63.0734 10.0878V7.71996H63.6563V11.7664H63.0477L60.7408 8.46585H60.7158L60.7408 9.24545V11.7664H60.1593Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8697 9.90701C38.8697 10.4722 38.6822 10.922 38.3064 11.2578C37.88 11.6571 37.3235 11.8567 36.64 11.8567C35.9852 11.8567 35.4279 11.6544 34.9705 11.2497C34.5123 10.8444 34.2832 10.3427 34.2832 9.7438C34.2832 9.14426 34.5123 8.6425 34.9705 8.23786C35.4279 7.83254 35.9852 7.63022 36.64 7.63022C36.9651 7.63022 37.2759 7.68687 37.5708 7.7995C37.8664 7.9128 38.103 8.06319 38.28 8.25135L37.8815 8.60743C37.5813 8.28709 37.1677 8.12726 36.6392 8.12726C36.1614 8.12726 35.7485 8.27698 35.4 8.57641C35.0514 8.87584 34.8775 9.26497 34.8775 9.74313C34.8775 10.2213 35.0514 10.6104 35.4 10.9098C35.7485 11.2093 36.1614 11.359 36.6392 11.359C37.1458 11.359 37.5685 11.2086 37.9065 10.9071C38.1257 10.7109 38.2528 10.4378 38.2868 10.0877H36.6392V9.6015H38.8372C38.8599 9.70738 38.8697 9.80922 38.8697 9.90701Z",
    stroke: "white",
    strokeWidth: 0.0281855,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3555 8.21699H40.2898V9.4997H42.1528V9.98595H40.2898V11.2687H42.3555V11.7664H39.7068V7.71996H42.3555V8.21699Z",
    stroke: "white",
    strokeWidth: 0.0281855,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8135 11.7664H44.2305V8.21699H42.9633V7.71996H46.0807V8.21699H44.8135V11.7664Z",
    stroke: "white",
    strokeWidth: 0.0281855,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3361 11.7664V7.71996H48.9191V11.7664H48.3361Z",
    stroke: "white",
    strokeWidth: 0.0281855,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5043 11.7664H50.9214V8.21699H49.6542V7.71996H52.7716V8.21699H51.5043V11.7664Z",
    stroke: "white",
    strokeWidth: 0.0281855,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6728 11.2437C58.2267 11.6524 57.6725 11.8567 57.0094 11.8567C56.3463 11.8567 55.792 11.6524 55.3467 11.2437C54.9006 10.835 54.6783 10.3346 54.6783 9.74316C54.6783 9.15171 54.9006 8.6513 55.3467 8.24261C55.792 7.83392 56.3463 7.62891 57.0094 7.62891C57.6687 7.62891 58.2222 7.8346 58.6698 8.24531C59.1174 8.65602 59.3412 9.15508 59.3412 9.74316C59.3412 10.3346 59.1182 10.835 58.6728 11.2437ZM55.7769 10.9045C56.1126 11.208 56.5232 11.359 57.0094 11.359C57.4956 11.359 57.9069 11.2073 58.2418 10.9045C58.5775 10.601 58.7462 10.2139 58.7462 9.74316C58.7462 9.27242 58.5775 8.88532 58.2418 8.58184C57.9069 8.27836 57.4956 8.12729 57.0094 8.12729C56.5232 8.12729 56.1126 8.27903 55.7769 8.58184C55.442 8.88532 55.2734 9.27242 55.2734 9.74316C55.2734 10.2139 55.442 10.601 55.7769 10.9045Z",
    stroke: "white",
    strokeWidth: 0.0281855,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1593 11.7664V7.71996H60.8686L63.0734 10.8674H63.0983L63.0734 10.0878V7.71996H63.6563V11.7664H63.0477L60.7408 8.46585H60.7158L60.7408 9.24545V11.7664H60.1593Z",
    stroke: "white",
    strokeWidth: 0.0281855,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_4972_524",
    x: 12.8691,
    y: 7.60547,
    width: 18.502,
    height: 18.7891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.109566
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4972_524"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.109566
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_4972_524",
    result: "effect2_innerShadow_4972_524"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_4972_524",
    x: 13.2422,
    y: 17,
    width: 13.3711,
    height: 9.39453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.109566
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4972_524"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4972_524",
    x1: 22.3465,
    y1: 8.75242,
    x2: 10.1406,
    y2: 22.1421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4972_524",
    x1: 31.9882,
    y1: 16.9984,
    x2: 12.6005,
    y2: 16.9984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4972_524",
    x1: 24.7743,
    y1: 18.6756,
    x2: 8.22156,
    y2: 36.8337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4972_524",
    x1: 10.7273,
    y1: 2.5186,
    x2: 18.1185,
    y2: 10.6267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayButton);
export default __webpack_public_path__ + "static/media/Google-play-button.0263bdb9710d2579b1db0b15786b57dd.svg";
export { ForwardRef as ReactComponent };